import { NgModule } from '@angular/core';
import { NgIconsModule } from '@ng-icons/core';
import {
  saxHome2Outline,
  saxUserOutline,
  saxNotificationOutline,
  saxCodeOutline,
  saxArrowSwapHorizontalOutline,
  saxProfile2userOutline,
  saxBookOutline,
  saxMessageOutline,
  saxLogoutOutline,
  saxMenuOutline,
  saxArrowRight3Outline,
  saxCopyOutline,
  saxAddCircleOutline,
  saxEdit2Outline,
  saxTrashOutline,
  saxPeopleOutline,
  saxSetting2Outline,
  saxDocumentUploadOutline,
  saxSetting5Outline,
  saxInfoCircleOutline,
  saxMessageQuestionOutline,
  saxClipboardTextOutline,
  saxSendOutline,
  saxChartOutline,
  saxUserAddOutline,
  saxAddOutline,
  saxArrowDown1Outline,
  saxArrowUp2Outline,
  saxPlayOutline,
  saxCloseCircleOutline,
  saxMenu1Outline,
  saxGraphOutline,
  // ,
  // saxDeviceMessageOutline
} from '@ng-icons/iconsax/outline';

@NgModule({
  imports: [
    NgIconsModule.withIcons({
      saxHome2Outline,
      saxUserOutline,
      saxNotificationOutline,
      saxCodeOutline,
      saxArrowSwapHorizontalOutline,
      saxProfile2userOutline,
      saxBookOutline,
      saxMessageOutline,
      saxLogoutOutline,
      saxMenuOutline,
      saxArrowRight3Outline,
      saxCopyOutline,
      saxAddCircleOutline,
      saxEdit2Outline,
      saxTrashOutline,
      saxPeopleOutline,
      saxSetting2Outline,
      saxDocumentUploadOutline,
      saxInfoCircleOutline,
      saxSetting5Outline,
      saxMessageQuestionOutline,
      saxClipboardTextOutline,
      saxSendOutline,
      saxChartOutline,
      saxUserAddOutline,
      saxAddOutline,
      saxArrowDown1Outline,
      saxArrowUp2Outline,
      saxPlayOutline,
      saxCloseCircleOutline,
      saxMenu1Outline,
      saxGraphOutline
    }),
  ],
  exports: [NgIconsModule],
})
export class IconsModule {}
